export const apiUrl = "https://mnaleisureapi.waepos.com/";
